import React from "react";
import styled from "styled-components/macro";

class StyledCaseUpdateInfo extends React.Component {
  render() {
    return <CaseUpdateInfo>{this.props.children}</CaseUpdateInfo>;
  }
}

export default StyledCaseUpdateInfo;

const CaseUpdateInfo = styled.div`
  color: var(--juno-color-grey);
  line-height: 1.5;
  margin-top: var(--juno-space-2);
`;
